// eslint-disable-next-line import/prefer-default-export
export const mediaTypes = {
  GRAPHICS: 'graphics',
  CLIP: 'clip',
};
